import { generatePath } from 'utils/url';

export const ADMIN_SIGN_IN_WITH_TOKEN_PATH = '/admin/sign-in-with-token';
export const CUSTOM_PAGE_PATH = '/admin/design/:id(\\d+)';
export const ADMIN_ROOT_PATH = '/admin/design';
export const ADMIN_BLOCK_PREVIEW_PATH = '/admin/block-preview';
export const ADMIN_BLOCK_LIBRARY_PREVIEW_PATH = '/admin/block-library-preview';
export const ADMIN_CUSTOM_PAGE_SCREENSHOT_PREVIEW_PATH = '/admin/custom-page-screenshot-preview';

export const buildAdminPreviewCustomPagePath = (id) => generatePath(CUSTOM_PAGE_PATH, { id });
